import { render, staticRenderFns } from "./BalancePill.vue?vue&type=template&id=411753a3&scoped=true&"
import script from "./BalancePill.vue?vue&type=script&lang=js&"
export * from "./BalancePill.vue?vue&type=script&lang=js&"
import style0 from "./BalancePill.vue?vue&type=style&index=0&id=411753a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411753a3",
  null
  
)

export default component.exports